<div class="dialog-container">
    <h2 mat-dialog-title>Data Overzicht</h2>

    <mat-dialog-content>
        <p>Aantal features: {{data.features.length}}</p>

        <div class="table-container">
            <table class="data-table">
                <thead>
                <tr>
                    <th *ngFor="let prop of data.shapefileProperties">{{prop}}</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let feature of data.features">
                    <td *ngFor="let prop of data.shapefileProperties">{{feature.properties[prop]}}</td>
                </tr>
                </tbody>
            </table>
        </div>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <button mat-button (click)="onClose()">Sluiten</button>
    </mat-dialog-actions>
</div>
